import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface ThreeDSecureNotSupportedEventProperties {
  checkout_id: string
}

export class ThreeDSecureNotSupportedEvent extends Event<ThreeDSecureNotSupportedEventProperties> {
  static displayName = '3D Secure Not Supported'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
